import { useMemo } from 'react';
import platform from 'platform';
const useOsSettings = () => {
    const isMacOs = useMemo(() => {
        return platform.os?.family === 'OS X';
    }, []);
    const deleteKeyCode = useMemo(() => {
        return isMacOs ? 'Backspace' : 'Delete';
    }, [isMacOs]);
    return { isMacOs, deleteKeyCode };
};
export { useOsSettings };
//# sourceMappingURL=useOsSettings.js.map